module.exports = __webpack_public_path__ + "img/1.526e43ab.jpg";